<template>
    <div id="about-gunspring-page">
        <div class="container">
            <b-row class="form">
                <b-col cols="12" class="col-sm-6">
                    <p class="form-title">Contact Us</p>
                    <b-form @submit="onSubmit">
                        <b-form-group
                            id="input-group-1"
                            label-for="input-1"
                        >
                            <b-form-input
                            id="input-1"
                            v-model="form.name"
                            placeholder="Your name"
                            required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-1"
                            label-for="input-1"
                        >
                            <b-form-input
                            id="input-1"
                            v-model="form.email"
                            type="email"
                            placeholder="Your email address"
                            required
                            ></b-form-input>
                        </b-form-group>
                        <p></p>
                        <b-form-group
                            id="input-group-2"
                            label-for="input-2"
                        >
                            <b-form-textarea
                                id="input-2"
                                placeholder="Your message here..."
                                rows="6"
                                no-resize
                                required
                                v-model="form.text"
                            ></b-form-textarea>
                        </b-form-group>
                        <p></p>
                        <div style="display:flex;">
                            <p v-if="wasSent" class="success-message"><i class="fas fa fa-check-circle icon"></i>Message sent</p>
                            <b-button v-if="isSending" disabled class="form-button sending" type="submit"><i class="fa fa-spinner fa-pulse fa fa-fw icon"></i>Sending</b-button>
                            <b-button v-else class="form-button" @click="hideMessage" type="submit">Send</b-button>
                        </div>
                    </b-form>
                </b-col>
                <b-col cols="12" class="col-sm-1" style="padding: 25px 0"></b-col>
                <b-col cols="12" class="col-sm-5">
                    <p class="form-title">Address</p>
                    <p>1 Riverfront <br/>Place Ste. 415 <br/>North Little Rock, AR 72114</p>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        form: {
            email: "",
            text: "",
            name: ""
        },
        isSending: false,
        wasSent: false
    }),
    methods: {
        onSubmit(event) {
            event.preventDefault()
            this.isSending = true;
            this.$store
                .dispatch("contactUs", this.form)
                .then(res => {
                    // this.makeToast('success', 'Success!', 'Yor request was sent.')
                    this.form = {
                        email: '',
                        text: '',
                        name: ''
                    }
                    this.isSending = false;
                    this.wasSent = true;
                    setTimeout(this.hideMessage, 10000);
                })
                .catch(err => {
                    // this.makeToast('danger', 'Error!', 'Failed to send your request.')
                    this.isSending = false;
                });
            // alert(JSON.stringify(this.form))
        },
        makeToast(variant = null,title = 'Error', message = 'There is an error on system') {
            this.$bvToast.toast(message, {
            title: title,
            variant: variant,
            // toaster: 'b-toaster-top-center',
            solid: true
            })
        },
        hideMessage(){
            this.wasSent=false;
        }
    },
}
</script>

<style lang="css" scoped>
.page-banner {
    padding: 25px 0 30px 0;
    background-size: cover;
    background-position: center center;
    position: relative;
    background-color: darkgrey;
}
.page-banner-title {
    font-size: 36px;
    font-weight: bold;
    text-shadow: 1px 1px black;
    color: white;
    margin: 0;
    text-transform: uppercase;
}
.form {
    padding: 50px 0;
}
.form-title {
    font-size: 20px;
    font-weight: 600;
}
.form-button {
    width: 125px;
    margin-left: auto;
}
.success-message {
    align-self: center;
    margin-bottom: 0px;
    font-weight: bold;
    color: #1976d2;
    transition: visibility 0s, opacity 0.5s linear;
}
.success-message .icon {
    padding-right: 5px;
}

@media screen and (max-width: 767.98px) {
    .page-banner-title {
        font-size: 20px;
    }
    .form-button {
        width: 105px;
    }
}
</style>